/**
 * Full-screen overlay shown while a sign-out flushes every app's pending plays
 * to the server before wiping local data. Blocks interaction (no cancel — the
 * point is to not lose data) and shows a spinner + message.
 */
export function LogoutSyncOverlay({
  open,
  message = "Saving your data before signing out…",
}: {
  open: boolean;
  message?: string;
}) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[130000] flex items-center justify-center bg-black/50"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4 rounded-lg bg-white px-8 py-6 shadow-lg">
        <span
          className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"
          aria-hidden="true"
        />
        <p className="max-w-[16rem] text-center text-sm font-medium text-gray-900">
          {message}
        </p>
      </div>
    </div>
  );
}

export default LogoutSyncOverlay;
